var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgObjTitleRing(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 238,
    height: 51,
    viewBox: "0 0 238 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M236.889 38.1607C236.75 39.4358 235.892 40.674 234.222 41.8516C232.555 43.0273 230.139 44.0968 227.028 45.0411C220.81 46.9286 211.932 48.2821 201.022 49.046C179.212 50.5733 149.381 49.7378 116.705 46.1722C84.0297 42.6066 54.721 36.9887 33.7528 30.7933C23.2647 27.6944 14.8875 24.458 9.22292 21.2739C6.38875 19.6808 4.26056 18.1155 2.88611 16.6078C1.50956 15.0979 0.939075 13.7038 1.07821 12.4287C1.21734 11.1537 2.07508 9.91544 3.74489 8.7379C5.41216 7.56216 7.82785 6.49272 10.9389 5.54836C17.1569 3.6609 26.035 2.3074 36.9446 1.54347C58.7555 0.0162007 88.586 0.851671 121.262 4.41728C153.937 7.9829 183.246 13.6008 204.214 19.7962C214.702 22.895 223.079 26.1315 228.744 29.3156C231.578 30.9087 233.706 32.474 235.081 33.9816C236.457 35.4916 237.028 36.8857 236.889 38.1607Z",
    stroke: "url(#paint0_linear_337_1098)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_337_1098",
    x1: -16.6734,
    y1: 40.3778,
    x2: 13.0867,
    y2: -46.3376,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4AE6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FC72FF",
    stopOpacity: 0.06
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgObjTitleRing);
export default __webpack_public_path__ + "static/media/obj-title-ring.699015cbb1f960bfc5650a24004e7025.svg";
export { ForwardRef as ReactComponent };